export const PATH_HOME = "/";
export const PATH_DASHBOARD = "/dashboard";
export const PATH_DONORS = "/donors";
export const PATH_USERS = "/users";


export const PATH_ADD_PERSON = "/people/person/new-donor"
export const PATH_ADD_DONOR = "/donors/donor/new-person"
export const PATH_DONOR_VIEW = '/donors/donor/:id'
export const PATH_DONOR_EDIT = '/donors/donor/edit/:id'

export const PATH_USER_ADD = '/users/user/new-user'
export const PATH_USER_EDIT = '/users/user/edit/:id'

// Super admin routes
export const PATH_USER_ROLES = '/users/roles';
export const PATH_USER_PERMISSIONS = '/users/permissions';

export const PATH_PROFILE = '/profile';
export const PATH_UNSUBSCRIBE = '/unsubscribe';

export const PATH_CONTACT = '/contact';

export const PATH_LOGIN = '/login';
export const PATH_FORGOT_PASSWORD = '/forgot-password';
export const PATH_RESET_PASSWORD = '/reset-password';
